import { apiConnector } from "../apiConnector"
import { apiClient } from "../apiClient"

import { toast } from "react-hot-toast"
import { Manager_Profile,profile } from "./Auth";
import {Get_Devices,Get_Org_Devices} from "./Device"
import {Get_Managers} from './Manager'
import {Get_Managers_User,Get_Users} from './Users'

export function Org_SetTimeZone(formData){
    const token = localStorage.getItem('token')
    return async(dispatch)=>{
        try {
            
            const response = await apiConnector("PUT",apiClient.ORG_TIMEZONE,formData,
               { Authorization:`Bearer ${token}`}
            )
            if(!response?.data?.success){
                throw new Error(response?.data?.message)
            }
            dispatch(profile(token))
            dispatch(Get_Org_Devices(token))
            dispatch(Get_Users(token))
            dispatch(Get_Managers(token))
            toast.success(response?.data?.message)
        } catch (error) {
            const message = error.response?.data?.message||error.message
            console.log("Error In SetTimeZone Function Calling:",message)
            toast.error(message)
        }
    }
}
export function SetTimeZone(formData){
    const token = localStorage.getItem('token')
    return async(dispatch)=>{
        try {
            
            const response = await apiConnector("PUT",apiClient.TIMEZONE,formData,
               { Authorization:`Bearer ${token}`}
            )
            if(!response?.data?.success){
                throw new Error(response?.data?.message)
            }
            dispatch(Manager_Profile(token))
            dispatch(Get_Devices(token))
            dispatch(Get_Managers_User(token))
            toast.success(response?.data?.message)
        } catch (error) {
            const message = error.response?.data?.message||error.message
            console.log("Error In SetTimeZone Function Calling:",message)
            toast.error(message)
        }
    }
}